import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { getRouteWithPrevLocation } from "@/react/helpers/urlHelpers";
import { formattedMessageSentAt } from "@circle-react/helpers/dateTimeHelpers/formattedMessageSentAt";
import { dateStringToTimeAgo } from "@circle-react/helpers/dateTimeHelpers/timeAgo";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import {
  getChatRoomMessageRedirectionHash,
  getChatRoomUrl,
  getChatThreadMessageRedirectionHash,
} from "../../helpers";

export interface MessageTimestampProps {
  chatRoom: any;
  isMessageThread?: boolean;
  isParentMessage?: boolean;
  isRenderedOnHeader?: boolean;
  message: any;
}

export const MessageTimestampLink = ({
  message,
  chatRoom,
  isParentMessage = false,
  isMessageThread = false,
  isRenderedOnHeader = false,
}: MessageTimestampProps) => {
  const { id, sent_at: sentAt } = message;
  const { day, time } = formattedMessageSentAt(sentAt);
  const timeAgo = dateStringToTimeAgo(sentAt);

  const getMessageTime = () => {
    if (isMessageThread) {
      return isParentMessage ? `${day} at ${time}` : timeAgo;
    }
    return time;
  };

  const isSent = !!id && id > 0;

  return (
    <Link
      to={getRouteWithPrevLocation({
        url: getChatRoomUrl(chatRoom, message),
        hash: isParentMessage
          ? getChatRoomMessageRedirectionHash(message)
          : getChatThreadMessageRedirectionHash(message),
        search: isParentMessage ? "" : `message_id=${message.id}`,
      })}
      className={classNames({
        "inline-flex flex-row items-center": isRenderedOnHeader,
      })}
    >
      <span className="text-light inline cursor-pointer text-xs hover:underline">
        {isSent ? getMessageTime() : t("messaging.sending")}
      </span>
    </Link>
  );
};
